(ns app.front.view.group.reporting.escrow
  (:require [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.reporting.common :as reporting-common]
            [app.front.view.group.reporting.download-button :as rdb]
            [app.front.view.group.reporting.filters :as reporting-filters]
            [app.front.view.group.reporting.list :as report-list]
            [app.reporting.model :as reporting-model]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [schema.core :as s]))


(rf/reg-event-db ::set-selected
  (rf/path [::data])
  (fn [data [_ k v]]
    (assoc data k v)))


(rf/reg-sub ::data :-> ::data)


(rf/reg-sub ::report-type
  :<- [::data]
  (fn [data _]
    (::report-type data (first reporting-model/escrow-report-types))))


(rf/reg-sub ::query
  :<- [::gas/group-id]
  :<- [::report-type]
  :<- [::reporting-common/date-range]
  (fn [[group-id report-type [start-date end-date]] _]
    (-> {:group-id    group-id
         :report-type report-type}
        (p/assoc-if :start-date (when-not (= report-type :reporting.escrow/balance) start-date)
                    :end-date (when-not (= report-type :reporting.escrow/balance) end-date)))))


(defn view [match]
  (let [tr           (<sub [::gas/group-tr])
        report-type  (<sub [::report-type])
        query        (<sub [::query])
        report-types reporting-model/escrow-report-types]
    [reporting-common/report-page
     match
     tr
     [:section
      [:h3 (tr [:reporting/select-report])]
      [reporting-common/report-type-selector
       {:tr                  tr
        :label-loc           :reporting/report-type
        :on-change           #(>evt [::set-selected ::report-type (nth report-types %)])
        :report-type-options report-types
        :selected-index      (p/find-index report-types #(= % report-type))}]
      (if (not= report-type :reporting.escrow/balance)
        [reporting-common/date-range-selector tr "escrow-date-range" reporting-common/date-range-options]
        [:div.text-gray-600.mt-6 (tr [:reporting.escrow/range-not-available])])]
     [rdb/generate-button (util/mmap query tr)]
     [report-list/list-section (util/mmap tr report-type)]]))



(def route
  {:name        :view/group.reporting.escrow
   :view        view
   :parameters  {:path {:group-id s/Int}}
   :controllers [{:parameters {:path [:group-id]}
                  :start      (fn [params]
                                (let [group-id (-> params :path :group-id)]
                                  (>evt [::reporting-filters/fetch-saved-filters group-id])
                                  (>evt [::reporting-common/init group-id (first reporting-common/date-range-options)])))}]})
